import { css } from 'styled-components';

// 화면 크기를 기준으로 스타일을 정의하는 sizes 객체
const sizes = {
    mobile: 480,
    tablet: 768,
  };
  
// 미디어 쿼리를 관리할 수 있는 유틸리티 함수
export const media = {
    mobile: (args: TemplateStringsArray, ...values: any[]) => css`
      @media (max-width: ${sizes.mobile}px) {
        ${css(args, ...values)}
      }
    `,
    tablet: (args: TemplateStringsArray, ...values: any[]) => css`
      @media (min-width: ${sizes.mobile}px) and (max-width: ${sizes.tablet}px) {
        ${css(args, ...values)}
      }
    `,
    desktop: (args: TemplateStringsArray, ...values: any[]) => css`
      @media (min-width: ${sizes.tablet}px) {
        ${css(args, ...values)}
      }
    `,
  };